import VibeStreamLogo from "../assets/new-logo.png";

function LogoModalHeader() {
  return (
    <div className="auth-modal-header">
      <img src={VibeStreamLogo} alt="VibeStream Logo" className="logo" />
    </div>
  );
}

export default LogoModalHeader;
